import {
  Box,
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import React from "react";

const Journeys = () => {
  return (
    <Card sx={{ mt: 4 }} className="cards">
      <Box className="custom_tabs">
        <h2 className="mn_hdng">Active And Completed Journeys</h2>
      </Box>
      <TableContainer className="table_container">
        <Box className="heading"></Box>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell align="center">S.No</TableCell>
              <TableCell align="center">Image/Video</TableCell>
              <TableCell>Bucket Title</TableCell>
              {/* <TableCell>Description</TableCell> */}
              {/* <TableCell>Location</TableCell> */}
              <TableCell>Journey Type</TableCell>
              <TableCell>Category</TableCell>
              <TableCell>Status</TableCell>

              {/* <TableCell>Target Date</TableCell> */}
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell align="center">{1}</TableCell>
              <TableCell align="center">
                <figure className="user_img">
                  <img src="/static/images/post.png" alt="" />
                </figure>
              </TableCell>
              <TableCell>Going to Paris</TableCell>
              {/* <TableCell>Lore</TableCell> */}
              {/* <TableCell>Bhumibandara Hotel</TableCell>{" "} */}
              <TableCell>Private</TableCell>
              <TableCell>Travel</TableCell>
              {/* <TableCell></TableCell> */}
              <TableCell>Completed</TableCell>
              {/* <TableCell>Accepted</TableCell> */}
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Card>
  );
};

export default Journeys;
